export default {
    edit_alert_type_supported_title: "Edit Alert Type Device Model",
    edit_alert_type_supported_success_message: "The device model has been edited",
    edit_alert_type_supported_error_message: "The device model has not been edited",

    edit_alert_type_supported_contract_all: "Contract All",
    edit_alert_type_supported_expand_all: "Expand All",
}